<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='月度绩效报表' url='/report/achievement/stumonth'></SearchTitle>
      <div class="m-portlet__body">
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.sec' label='科室' :dictid='this.$utils.DictEnum.section'></ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">考核月份：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.assessmentmonth" type="month" placeholder="考核月份" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">是否需考试：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.isexam" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in examOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <el-button type="primary" icon="el-icon-search" @click="Search(1)">查询</el-button>
          <el-button type="primary" icon="el-icon-download" @click="StuOut">导出</el-button>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" ref="multipleTable" :data="tableData" stripe style="width: 100%" size="medium">
            <!-- <el-table-column type="selection" width="55">
            </el-table-column> -->
            <el-table-column>
              <template slot="header">
                姓名<br>工号
              </template>
              <template slot-scope="scope">
                {{scope.row.StuName}}<br>{{scope.row.StuNo}}
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header">
                轮转科室<br>专业
              </template>
              <template slot-scope="scope">
                {{scope.row.SectionName}}<br>{{scope.row.SpecialityName}}
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header">
                用户类型<br>培养年限
              </template>
              <template slot-scope="scope">
                {{scope.row.UserTypeName}}<br>{{scope.row.StuEduYearName}}
              </template>
            </el-table-column>
            <el-table-column width="80">
              <template slot="header">
                执医<br>交通
              </template>
              <template slot-scope="scope">
                {{scope.row.IsDoctorName}}<br>{{scope.row.IsTrafficName}}
              </template>
            </el-table-column>
            <el-table-column prop="AllLeaveDay" label="缺勤天数" width="80">
            </el-table-column>
            <el-table-column prop="LiveName" label="是否住宿" width="80">
            </el-table-column>
            <el-table-column prop="IsExamName" label="是否需要参加考试">
            </el-table-column>
            <el-table-column prop="IsResultsName" label="是否完成考试">
            </el-table-column>
            <el-table-column prop="ResultsTypeName" label="考试类型">
            </el-table-column>
            <el-table-column prop="BedState" label="管床工作量">
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        condition: {
          token: '',
          truename: '',
          sec: '',
          cardno: '',
          assessmentmonth: '',
          isexam: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0
        },
        examOptions: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }],
        tableData: '',
        tabStuAchievement: null,
        loading: true
      }
    },
    methods: {
      Search: function(index) {
        this.loading = true
        if (index != null) {
          this.condition.currentPage = 1
        }
        if (this.condition.assessmentmonth == '' || this.condition.assessmentmonth == null) {
          this.$message({
            message: '考核月份不能为空',
            type: 'error'
          })
          this.loading = false
          return
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/StuReportList', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              this.tableData = res.data.Data
              this.condition.recordCount = res.data.Pager.RecordCount
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            this.tableData = null
            this.condition.recordCount = 0
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      },
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.currentPage = val
        this.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.Search()
      },
      StuOut: function() {
        this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/StuReportListOut', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              var filename = res.data.Data
              var url = this.$utils.Url.zpgl + '/doc/' + filename
              window.open(url)
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '导出失败',
              type: 'error'
            })
          })
      }
    },
    mounted: function() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      this.condition.assessmentmonth = year + '-' + month
      this.condition.token = sessionStorage.getItem('token')
      this.Search()
    }
  }
</script>

<style scoped="scoped">
  @import '../../../assets/css/achievementinfo.css'
</style>
